import React, {Component} from 'react';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';

export default class FlowersCTA extends Component {
  static propTypes = {
    data: React.PropTypes.object,
    image: React.PropTypes.string,
    text: React.PropTypes.string,
    link: React.PropTypes.string,
  };

  handleSendFlowersClick = () => {
    getGATags({
      eventCategory: 'fhd_flowers',
      eventAction: 'fhd_flowersad_click',
      eventLabel: 'fhd_flowerad',
    });
  };

  render() {
    const {image, text, link} = this.props.data;

    return (
      <a
        href={link}
        className="flowers-cta-item"
        data-ga-no-auto-tag
        onClick={this.handleSendFlowersClick}
      >
        <div className="image" style={{backgroundImage: `url(${image})`}} />
        <div className="description">{text}</div>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/FlowersAd/FlowersCTA.js